var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusybusyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.36 46.53",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#fabd14",
    cx: 22.74,
    cy: 23.03,
    r: 20.03
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.5,36.81,16,33.72a5.6,5.6,0,0,1-3.59-7l6-18.42a2.05,2.05,0,0,1,3.9,1.27L16.3,28a1.49,1.49,0,0,0,1,1.87l9.51,3.09,2.39-7.34L21.9,23.21a2.05,2.05,0,0,1,1.27-3.9l7.61,2.47a3.75,3.75,0,0,1,2.39,4.7l-2.5,7.7A4.11,4.11,0,0,1,25.5,36.81Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusybusyIcon);
export default __webpack_public_path__ + "static/media/busybusy_icon.52fa1f5711a32f9048379f29e97a595a.svg";
export { ForwardRef as ReactComponent };